import React from 'react';
import { ThemeProvider } from 'fronton-react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { SpecialOffer, SpecialOfferProps } from 'remotes/special-offer';
import { RemoteProps } from './widgets-types';

type SpecialOfferRemoteProps = SpecialOfferProps & Omit<RemoteProps, 'router'>;

export const SpecialOfferRemote: React.FC<SpecialOfferRemoteProps> = ({ store, ...props }) => (
  <ThemeProvider>
    <Baseline>
      <StoreContext.Provider value={store}>
        <SpecialOffer {...props} />
      </StoreContext.Provider>
    </Baseline>
  </ThemeProvider>
);
